<nb-layout withScroll>
  <nb-layout-header fixed *ngIf="withMenu">
    <app-navbar></app-navbar>
  </nb-layout-header>
  <nb-layout-column class="p-0 bg-light gel__page">
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>